import { render } from "./external-exam-show.vue?vue&type=template&id=13f0005e&scoped=true"
import script from "./external-exam-show.vue?vue&type=script&lang=js"
export * from "./external-exam-show.vue?vue&type=script&lang=js"

import "./external-exam-show.vue?vue&type=style&index=0&id=13f0005e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f0005e"]])

export default __exports__